export const localEvents = [
  {
    eventId: '2004380e-6a85-4e03-9ba1-02368b5957c4',
    acts: [
      {
        id: '2059d0f1-66cd-485a-a12d-53d177118700',
        eventPartition: '1/3',
        time: '1687875129398',
        type: 'COLLECTION_UPDATE_CHILD',
        payload: {
          entityId: 'd5966631-9a4a-47dd-ac09-dd2984a8b125',
          children: [
            {
              id: '4d99a84b-9b21-44c5-9bf6-d1d217519e82',
              type: 'note',
            },
          ],
          move: 'REMOVE',
          position: 0,
        },
      },
      {
        id: '27fc337b-75b5-484e-ad08-328f752b1944',
        eventPartition: '2/3',
        time: '1687875129398',
        type: 'COLLECTION_UPDATE_CHILD',
        payload: {
          entityId: '324e0c5a-bdd8-477a-a3d5-e46393cfde26',
          children: [
            {
              id: '4d99a84b-9b21-44c5-9bf6-d1d217519e82',
              type: 'note',
            },
          ],
          move: 'ADD',
          position: 0,
        },
      },
      {
        id: '2dd2a652-ba1e-48e0-b13e-364aa0aa151c',
        eventPartition: '3/3',
        time: '1687875129398',
        type: 'NODE_PARENT_UPDATE',
        payload: {
          ref: {
            id: '4d99a84b-9b21-44c5-9bf6-d1d217519e82',
            type: 'note',
          },
          parentId: '324e0c5a-bdd8-477a-a3d5-e46393cfde26',
        },
      },
    ],
    time: '1687875129398',
  },
  {
    eventId: '8a7359bf-33b6-4b3a-836f-7947af3d9857',
    acts: [
      {
        id: 'd25f1720-38f4-4c7a-9905-dfbfc5c76862',
        eventPartition: '1/1',
        time: '1687875455114',
        type: 'NOTE_UPDATE_CONTENT',
        payload: {
          entityId: '4d99a84b-9b21-44c5-9bf6-d1d217519e82',
          content:
            'Это объект, внутри которого была создана функция.\nКонтекст опредиляиться в момент вызова функции.\nthis является ссылкой на контекст.\n\nLexicalEnvironment\n\nЭто специально добавленный текст для тестирования.\n\nВсе переменные внутри функции – это свойства специального внутреннего объекта LexicalEnvironment, который создаётся при её запуске.\n\nИнтерпретатор, при доступе к переменной, сначала пытается найти переменную в текущем LexicalEnvironment, а затем, если её нет – ищет во внешнем объекте переменных. В данном случае им является window.\n\nЭто возможно через поле Scope у функции, это поле скрыто.\n\nЕсли обобщить:\n— Каждая функция при создании получает ссылку [[Scope]] на объект с переменными, в контексте которого была создана.\n— При запуске функции создаётся новый объект с переменными LexicalEnvironment. Он получает ссылку на внешний объект переменных из [[Scope]].\n—При поиске переменных он осуществляется сначала в текущем объекте переменных, а потом – по этой ссылке.\n\nВ браузере this === window\nВ ноде this === global\n\nВ строгом режиме this === undefined\n\nКаррирование — привязывание не только контекста, но и аргументов.\n\nПочитать насчёт Замыкания, Scope, LexicalEnvironment.\n\nhttps://habr.com/company/ruvds/blog/422089/\n\nНемного новых данных.',
          hash: '97a2e390113d627de720d8a83fcb3dd6c70f0ff2',
        },
      },
    ],
    time: '1687875455114',
  },
  {
    eventId: '8a7359bf-33b6-4b3a-836f-7947af3d0001',
    acts: [
      {
        id: 'd25f1720-38f4-4c7a-9905-dfbfc5c00001',
        eventPartition: '1/1',
        time: '1687875455114',
        type: 'NOTE_UPDATE_CONTENT',
        payload: {
          entityId: '4d99a84b-9b21-44c5-9bf6-d1d21e000001',
          content: 'Another local text to check',
          hash: '97a2e390113d627de720d8a83fcb3dd6c70f0ff2',
        },
      },
    ],
    time: '1687875455114',
  },
];
